module.exports = __WEBPACK_EXTERNAL_MODULE_2__;


//////////////////
// WEBPACK FOOTER
// external {"root":"glamor/react","commonjs2":"glamor/react","commonjs":"glamor/react","amd":"glamor/react"}
// module id = 2
// module chunks = 0